import React, { useEffect } from 'react';
import { Collapse, Icon, Tooltip } from 'antd';
import { Button, Table, Widget, MasterDetailForm, FormInput, ButtonDelete } from '@digital/ui';
import ModalIncluirAvaliacao from './ModalIncluirAvaliacao';
import { sasFornecedorAvaliacoes } from '@app/api/sas/sasFornecedor';
import { GetFileExtension, imageFormats } from '@app/helpers';
import { hasPermission } from '@app/helpers/permissions';

const { Panel } = Collapse;

interface FormularioTabelaAvaliacaoProps {
  headerPanel: string;
  incluir(fornecedorId: string, formValues: any): void;
  viewArquivoAnexo(id: string, nomeArquivo: string): void;
  downloadArquivo(id: string, nomeArquivo: string): void;
  excluir(id: string, fornecedorId: string): void;
  fornecedorId: string;
  dataSource: sasFornecedorAvaliacoes[];
  initialValues: any;
  fecharModalSucesso: boolean;
}

const FormularioTabelaAvaliacao = ({
  headerPanel,
  incluir,
  viewArquivoAnexo,
  downloadArquivo,
  excluir,
  fornecedorId,
  dataSource,
  initialValues,
  fecharModalSucesso,
}: FormularioTabelaAvaliacaoProps) => {
  useEffect(() => {}, []);

    const btns = (record: sasFornecedorAvaliacoes) => { 
    const itens = [];

    itens.push(
      <Tooltip title="Baixar Arquivo">
        <Button
          onClick={() => {
            downloadArquivo(record.id, record.nome);
          }}
          icon="ui-download"
        />
      </Tooltip>,
    );

    if (GetFileExtension(record.nome) === 'pdf' || imageFormats.includes(GetFileExtension(record.nome))) {
      itens.push(
        <Tooltip title="Visualizar Arquivo">
          <Button
            onClick={async () => {
              viewArquivoAnexo(record.id, record.nome);
            }}
            icon="files-view_file"
            name="btnViewArquivo"
          />
        </Tooltip>,
      );
    }

    if (hasPermission(['SAS_FORNECEDOR_EXCLUIR_ARQUIVOS_AVALIACAO'])) {
      itens.push(
        <Tooltip title="Deletar Item">
          <ButtonDelete
            icon="science-minus"
            type="link"
            confirm="Deseja realmente excluir este registro?"
            okText="Confirmar"
            onClick={() => {
              excluir(record.id, record.sasFornecedorId);
            }}
            className="btn-delete-without-text"
          />
        </Tooltip>,
      );
    }
    return itens;
  };

  return (
    <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
      <Panel key={`${headerPanel}`} header={`${headerPanel}`}>
        <MasterDetailForm initialValues={initialValues}>
          <Widget
            actions={[
              hasPermission(['SAS_FORNECEDOR_INCLUIR']) && (
                <ModalIncluirAvaliacao
                  incluir={incluir}
                  fornecedorId={fornecedorId}
                  fecharModalSucesso={fecharModalSucesso}
                />
              ),
            ]}>
            <FormInput label="Validade Atual" key='validadeAtual' name="validadeAtual" span={3} disabled />
            <FormInput label="Comentário" key="comentario" name="comentario" span={6} disabled />
          </Widget>
          <Widget actions={[]}>
            <Table
              rowKey="id"
              columns={(() =>{
                const baseColumns =[
                {
                  title: 'Numero',
                  key: 'Numero',
                  dataIndex: 'index',
                  width: '3%',
                },
                {
                  title: 'Nome',
                  key: 'Nome',
                  dataIndex: 'nome',
                },
                {
                  title: 'Responsável',
                  key: 'responsavel',
                  dataIndex: 'responsavel',
                },
                {
                  title: 'Validade',
                  key: 'Validade',
                  dataIndex: 'dataValidadeFormatada',
                },
                {
                  title: 'Inclusão',
                  key: 'dataInclusao',
                  dataIndex: 'dataInclusao',
                },
                {
                  title: 'Ações',
                  key: 'acoes',
                  dataIndex: '',
                  render: record => {
                    return btns(record);
                  },
                },              
            ];

            if (headerPanel === "Avaliação Financeira") {
              const inclusionColumnIndex = baseColumns.findIndex(column => column.key === 'dataInclusao');
      
              baseColumns.splice(inclusionColumnIndex, 0, {
                title: 'Resultado da Análise',
                key: 'resultadoAnaliseAvaliacaoFinanceira',
                dataIndex: 'resultadoAnaliseAvaliacaoFinanceira',
              });
            }
      
            return baseColumns;
          })()}
      
              dataSource={dataSource}
            />
          </Widget>
        </MasterDetailForm>
      </Panel>
    </Collapse>
  );
};

export default FormularioTabelaAvaliacao;
